import { useCallback, useContext } from 'react'

import { AssetWithdrawalContext } from '@/components/base/AssetWithdrawal/context'
import { TokenPickerRevampContext } from '@/components/base/TokenPickerRevamp/context'
import { CustomTokenInfo } from '@/utils/helpers'

import TopTokensList from '../../WrappedTokensFlow/TopTokensList'

const Container = () => {
  const { setSelectedToken } = useContext(AssetWithdrawalContext)
  const { setIsOpenPicker } = useContext(TokenPickerRevampContext)

  const onClickToken = useCallback((token: CustomTokenInfo) => {
    setIsOpenPicker(false)
    setSelectedToken(token)
  }, [setIsOpenPicker, setSelectedToken])

  return <TopTokensList onClickToken={onClickToken} />
}

export default Container
